
					const modules = import.meta.glob([
  "/src/mock/app.ts",
  "/src/mock/client_clientList.ts",
  "/src/mock/cloud_configurationCenter.ts",
  "/src/mock/cloud_dictionary.ts",
  "/src/mock/cloud_lowCode.ts",
  "/src/mock/cloud_notificationEvent.ts",
  "/src/mock/cloud_questionnaire.ts",
  "/src/mock/cloud_templateBlock.ts",
  "/src/mock/controlSetting_employees.ts",
  "/src/mock/controlSetting_permissions.ts",
  "/src/mock/controlSetting_role.ts",
  "/src/mock/control_menu.ts",
  "/src/mock/control_updateLogs.ts",
  "/src/mock/supplier_memberMenu.ts",
  "/src/mock/supplier_memu.ts",
  "/src/mock/supplier_permissions.ts",
  "/src/mock/supplier_supplierList.ts",
  "/src/mock/tenant_extension_requests.ts",
  "/src/mock/tenant_memberMenu.ts",
  "/src/mock/tenant_tenantManage.ts",
  "/src/mock/tenant_tenantNotifications.ts",
  "/src/mock/user.ts",
  "/src/mock/version_valueAdded.ts",
  "/src/mock/version_versionManage.ts"
], { eager: true });
					const fakeModuleList = Object.keys(modules).reduce((list, key) => {
						const module = modules[key] ?? {};
						if (module.default) {
							for (const moduleKey of Object.keys(module)) {
								const mod = modules[key][moduleKey] ?? [];
								const modList = Array.isArray(mod) ? [...mod] : [mod];
								return [...list, ...modList];
							}
						} else {
							return list;
						}
					}, []);
					window.__VITE__PLUGIN__FAKE__SERVER__.fakeModuleList = fakeModuleList;
				